import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchWhatIncludesCarousels } from 'action-creators/payway/whatIncludes';
import {
  getPurchaseButtonInfo,
  getPurchaseButtonInfoForEPGTransactions,
} from 'action-creators/payway/purchaseButtonInfo';
import { useVerifyIsMobile } from 'hooks/useVerifyIsMobile';
import { getTranslation } from 'utils/getTranslation';
import './styles.scss';
import ContentLoader from 'containers/Player/components/ContentLoader';
import { CLEAR_WHAT_INCLUDES_DATA } from 'action-creators/payway/whatIncludes/constants';
import { showModalCommercial } from 'reducers/modalLandingCommercial/modalLandingCommercial.actions';
import PinForm from 'containers/PinForm/PinForm';

import { showEpgTransactions } from 'containers/Player/actions/epgTransactions/epgTransactions.actions';
import { getInfoToShowTransactions } from 'containers/Player/components/EpgTransactions/utils/getInfoToShowTransactions';
import { getContentListV1 } from 'utils/homologacion/homologacion';
import { IMG_SIZE } from 'utils/homologacion/contants';
import { getGridDynamicImage, getGridPrimaryImage, getGridSecondaryImage } from './utils';
import { WhatIncludesCallcenter } from './components/WhatIncludesCallcenter';
import { WhatIncludesGridImg } from './components/WhatIncludesGridImg';

const WhatIncludes = ({ handleClick, translations, assets, fam }) => {
  const location = useLocation();
  const [planClicked, setPlanClicked] = useState(
    location.state ? location?.state?.planClicked : { family: fam },
  );
  const proveedorCode = location?.state?.proveedorCode;
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const whatIncludesData = useSelector(store => store.payway.whatIncludes);
  const [options, setOptions] = useState([]);
  const [showCallCenter, setShowCallCenter] = useState(false);
  const { isMobile } = useVerifyIsMobile(768);

  const layoutCanles = 'canal_offer';
  const layoutAddons = 'addon';

  const getLayout = offer_type => {
    if (offer_type === layoutCanles) {
      return layoutCanles;
    }
    if (offer_type === layoutAddons) {
      return layoutAddons;
    }
    return layoutCanles;
  };

  const pbi = useSelector(
    state => state.payway?.purchaseButtonInfo?.data?.listButtons?.button || [],
  );
  const region = useSelector(state => state.user.region);
  const usr = useSelector(state => state.user);
  const chevronBack = useSelector(state => state.asset?.top_head_option_back);
  const [imageOnLoadErrors, setimageOnLoadErrors] = useState({});

  useEffect(() => {
    dispatch(getPurchaseButtonInfoForEPGTransactions({ object_type: 'A' }));
  }, []);

  useEffect(
    () => {
      if (pbi?.length > 0 && options?.length === 0 && fam) {
        const opt = pbi?.filter(p => p?.family === fam);
        setOptions(opt);
      }
    },
    [pbi],
  );

  useEffect(
    () => {
      if (pbi?.length > 0 && options?.length === 0) {
        const availableOptions = pbi?.filter(
          o => o.family === planClicked?.family,
        );
        setOptions(availableOptions);
      }
    },
    [pbi],
  );

  useEffect(
    () => {
      if (pbi?.length > 0 && options?.length === 0) {
        const availableOptions = pbi?.filter(
          o => o.family === planClicked?.family,
        );
        setPlanClicked(availableOptions?.[0]);
        setOptions(availableOptions);
      }
    },
    [pbi],
  );

  useEffect(() => {
    dispatch(fetchWhatIncludesCarousels(planClicked?.family || proveedorCode));

    return () => {
      dispatch({ type: CLEAR_WHAT_INCLUDES_DATA });
    };
  }, []);

  const clickFun = (option, e) => {
    if (option.currency === '' && option.price === '') {
      setShowCallCenter(true);
      return;
    }
    if (handleClick) {
      handleClick(option, e);
    }
  };

  const renderPromotions = () =>
    ['One', 'Two', 'Three'].map(key => {
      const options = { Two: '2', Three: '3' };
      let logo = '';
      if (options[key] === '2') {
        logo = assets?.['LandingComercial_LogoTelmex'];
      } else if (options[key] === '3') {
        logo = assets?.['LandingComercial_LogoTelcel'];
      }

      const text = getTranslation(
        `LandingComercial_Texto${options[key]}_${planClicked?.producttype}`,
        translations,
      );
      if (text && logo) {
        return (
          <div className="what-includes-promo-block">
            {logo && <img src={logo} alt={logo} />}{' '}
            {text && <p className="what-includes-promo-text">{text}</p>}
          </div>
        );
      }
      return null;
    });
    
  const renderOptions = () =>
    options.map((option, index) => {
      let position = index + 1;

      return (
        <>
          {position === 1 && (
            <p className="what-includes-promo">
              <span className="what-includes-promo-blue">
                {getTranslation(
                  `LandingComercial_TextoPromo1_${option?.producttype}`,
                  translations,
                )}
              </span>
              <span className="what-includes-promo-white">
                {getTranslation(
                  `LandingComercial_TextoPromo2_${option?.producttype}`,
                  translations,
                )}
              </span>
            </p>
          )}
          {position === 2 && (
            <p className="what-includes-promo-special">
              {getTranslation(
                `LandingComercial_Texto5_${option?.producttype}`,
                translations,
              )}
            </p>
          )}
          <div className="what-includes-price">
            {option?.price && (
              <>
                <span className="what-includes-price-amount">
                  {getTranslation(
                    `LandingComercial_TextoPrecio${position}_${
                      option?.producttype
                    }`,
                    translations,
                  )}{' '}
                </span>

                <span className="what-includes-iva-message">
                  {' '}
                  {getTranslation(
                    `LandingComercial_TextoImpuestos${position}_${
                      option?.producttype
                    }`,
                    translations,
                  )}
                </span>
              </>
            )}
          </div>
          <button
            type="button"
            className="what-includes-purchase-button"
            onClick={e => clickFun(option, e)}
            style={{
              background: getTranslation('Color_ColorPrimario', translations),
            }}
          >
            {getTranslation(
              `LandingComercial_TextoBoton${position}_${option?.producttype}`,
              translations,
            )}
          </button>
          {index === 0 && (
            <p className="what-includes-disclaimer">
              {getTranslation(
                `LandingComercial_Texto4_${option?.producttype}`,
                translations,
              )}
            </p>
          )}
        </>
      );
    });

  const epgChannels = useSelector(state => state?.Player?.EpgChannels?.data);
  const groupId = location?.state?.groupId;

  const renderSecondaryImages = () => {
    const totalSecondaryImages =
      whatIncludesData.data.secondaryImages.length >= 4
        ? 4
        : whatIncludesData.data.secondaryImages.length;
    const gridLayout = `grid-gallery-layout-${totalSecondaryImages}-addon`;
    const gridLayout_canal_offer = `grid-gallery-layout-${totalSecondaryImages}-canal_offer`;

    return (
      <div
        className={`grid-gallery-layout-base ${gridLayout} ${
          getLayout(whatIncludesData?.offer_type) === layoutCanles
            ? gridLayout_canal_offer
            : ''
        }`}
      >
        {whatIncludesData?.data?.secondaryImages?.[1] && !imageOnLoadErrors[2] && (
          <WhatIncludesGridImg
            className="left-poster-1"
            contentInfo={whatIncludesData.data.secondaryImages}
            position={1}
            isMobile={isMobile}
            styles={{
              width: '100%',
              height: '100%',
            }}
            onError={() =>
              setimageOnLoadErrors({ ...imageOnLoadErrors, 2: true })
            }
            altText="Left poster 1"
            isAddon={whatIncludesData?.offer_type === layoutAddons}
          />
        )}
        {whatIncludesData?.data?.secondaryImages?.[2] && !imageOnLoadErrors[3] && (
          <WhatIncludesGridImg
          className="left-poster-2"
          contentInfo={whatIncludesData.data.secondaryImages}
          position={2}
          isMobile={isMobile}
          styles={{
            width: '100%',
            height: '100%',
          }}
          onError={() =>
            setimageOnLoadErrors({ ...imageOnLoadErrors, 3: true })
          }
          altText="Left poster 2"
          isAddon={whatIncludesData?.offer_type === layoutAddons}
        />
        )}
        {whatIncludesData?.data?.secondaryImages?.[3] && !imageOnLoadErrors[4] && (
          <WhatIncludesGridImg
          className="left-poster-3"
          contentInfo={whatIncludesData.data.secondaryImages}
          position={3}
          isMobile={isMobile}
          styles={{
            width: '100%',
            height: '100%',
          }}
          onError={() =>
            setimageOnLoadErrors({ ...imageOnLoadErrors, 4: true })
          }
          altText="Left poster 3"
          isAddon={whatIncludesData?.offer_type === layoutAddons}
        />
        )}
        {whatIncludesData?.data?.secondaryImages?.[0] && !imageOnLoadErrors[1] && (
          <WhatIncludesGridImg
          className="right-poster-1"
          contentInfo={whatIncludesData.data.secondaryImages}
          position={0}
          isMobile={isMobile}
          styles={{
            width: '100%',
            margin: '0px',
            height: '100%',
          }}
          onError={() =>
            setimageOnLoadErrors({ ...imageOnLoadErrors, 1: true })
          }
          altText="Right poster"
          isDynamicImg={true}
          isAddon={whatIncludesData?.offer_type === layoutAddons}
        />
        )}
      </div>
    );
  };

  if (whatIncludesData?.inProgress)
    return <ContentLoader backgroundColor="#121212" />;

  return (
    <>
      <WhatIncludesCallcenter
        displayCallCenter={showCallCenter}
        setDisplayCallCenter={setShowCallCenter}
      />
      <div className="what-includes-background">
        <img
          src={chevronBack}
          className="what-includes-backChevron"
          onClick={async () => {
            dispatch(showModalCommercial(false));
            if (
              location.pathname.includes('planselect') ||
              location.pathname.includes('whatincludes')
            ) {
              if (location?.state?.comeFromEpgTransactions) {
                await getInfoToShowTransactions(groupId, epgChannels, dispatch);
              }
              navigate(-1);
            }
          }}
        />
        <div className="what-includes-container">
          <div className="what-includes-content">
            <div className="what-includes-title-container">
              {translations[
                `LandingComercial_TextoNombreAddOn_${planClicked?.producttype}`
              ] ? (
                <p className="what-includes-plan-title">
                  {getTranslation(
                    `LandingComercial_TextoNombreAddOn_${
                      planClicked?.producttype
                    }`,
                    translations,
                  )}
                </p>
              ) : (
                translations[
                  `LandingComercial_PaqueteCanal_TextoNombreAddOn_${
                    planClicked?.producttype
                  }`
                ] && (
                  <p className="what-includes-plan-title">
                    {getTranslation(
                      `LandingComercial_PaqueteCanal_TextoNombreAddOn_${
                        planClicked?.producttype
                      }`,
                      translations,
                    )}
                  </p>
                )
              )}
            </div>
            <div className="what-includes-description-container">
              <p className="what-includes-description">
                {getTranslation(
                  `LandingComercial_Texto1_${planClicked?.producttype}`,
                  translations,
                )}
              </p>
            </div>
            {renderPromotions()}
            {renderOptions()}
          </div>
          {whatIncludesData.success && (
            <div className="what-includes-posters">
              <div className="what-includes-posters-top">
                <div style={{ height: '100%', width: '100%' }}>
                  {!imageOnLoadErrors[0] ? (
                    <img
                      src={ getGridPrimaryImage(whatIncludesData?.data?.primaryImage)}
                      className="img-superhighlight"
                      onError={() =>
                        setimageOnLoadErrors({ ...imageOnLoadErrors, 0: true })
                      }
                      alt=""
                    />
                  ) : (
                    <div className="img-superhighlight" />
                  )}
                </div>
              </div>
              <div className="what-includes-posters-bottom">
                {renderSecondaryImages()}
              </div>
            </div>
          )}
          {isMobile && (
            <div className="what-includes-content" style={{ marginTop: 0 }}>
              {renderOptions()}
            </div>
          )}
        </div>
        <PinForm />
      </div>
    </>
  );
};

WhatIncludes.propTypes = {
  logo: PropTypes.string,
  description: PropTypes.string,
  promo: PropTypes.shape({
    blue: PropTypes.string,
    white: PropTypes.string,
  }),
  currency: PropTypes.string,
  price: PropTypes.number,
  periodicity: PropTypes.string,
  buttonText: PropTypes.string,
  disclaimer: PropTypes.string,
};

WhatIncludes.defaultProps = {
  logo: '',
  description: '',
  promo: {
    blue: '',
    white: '',
  },
  currency: '',
  price: '',
  periodicity: '',
  buttonText: '',
  disclaimer: '',
};

export default WhatIncludes;
